import { ModulesMap, ModulesConfigMap } from '../modulesMaps'

export default {
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS]: {
		url: '/company/:companyId/identity_cards/', // FIXME: fix url
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS_PREVIEW]: {
		url: '/company/:companyId/identity_cards/:identityId/preview/', // FIXME: fix url
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARDS_PREVIEW]: {
		url: '/company/:companyId/identity_cards/:identityId/preview/', // FIXME: fix url
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].CREATE_IDENTITY_CARD]: {
		url: '/company/:companyId/identity_cards/',
		requestOptions: {
			method: 'POST',
		},
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].DELETE_IDENTITY_CARD]: {
		url: '/company/:companyId/identity_cards/:identityId/',
		requestOptions: {
			method: 'DELETE',
		},
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].GET_IDENTITY_CARD]: {
		url: '/company/:companyId/identity_cards/:identityId/',
		requestOptions: {
			method: 'GET',
		},
	},
	[ModulesConfigMap[ModulesMap.IDENTITY_CARDS].PATCH_IDENTITY_CARD]: {
		url: '/company/:companyId/identity_cards/:identityId/',
		requestOptions: {
			method: 'PATCH',
		},
	},
}
